import moment from 'moment';
import numeral from 'numeral';
import 'numeral/locales';
import h from 'virtual-dom/h';
import Inputmask from 'inputmask';
import ko from 'knockout';
import 'knockout.validation';
import flatpickr from 'flatpickr';
import { Dutch } from 'flatpickr/dist/l10n/nl.js';
import { english } from 'flatpickr/dist/l10n/default.js';
import { getCookie } from './custom/cookieHelpers';
import { listviewDefaults, listviewColumnActionDefaults, listviewRenderTypeDefaults } from './listview';
import './custom-packages/knockout-file-bindings/knockout-file-bindings';
import './knockout.bindings';
import { enGB, nl } from 'date-fns/locale'
import { setDefaultOptions } from 'date-fns';

const languageCookie = getCookie('.AspNetCore.Culture');
if (languageCookie && languageCookie.indexOf('en') > -1) {
    moment.locale('en-gb');
    numeral.locale('en-GB');
    flatpickr.localize(english);
    setDefaultOptions({ locale: enGB });
} else {
    moment.locale('nl-nl');
    numeral.locale('nl-nl');
    flatpickr.localize(Dutch);
    setDefaultOptions({ locale: nl });
}

listviewDefaults.tableProps = { className: 'table-bordered table-bordered-light' };
listviewDefaults.noResults = () => 'Geen resultaten';
listviewColumnActionDefaults.confirmTitle = 'Bevestig';
listviewColumnActionDefaults.confirmButtonProps = { className: 'btn btn-primary btn-normal btn-rounded pull-right' };
listviewColumnActionDefaults.cancelButtonProps = { className: 'btn btn-normal btn-rounded pull-right' };
listviewColumnActionDefaults.cancelHeaderButtonProps = { className: 'icon icon-normal icon-close-o' };
listviewColumnActionDefaults.confirmButtonContent = 'Bevestigen';
listviewColumnActionDefaults.cancelButtonContent = 'Annuleren';

listviewRenderTypeDefaults.datetime = (value: string, format: any) => {
    var date = moment(value);
    var formattedDate = date.format(format);
    return formattedDate;
};
listviewRenderTypeDefaults.number = (value: number, format: any) => {
    var num = numeral(value);
    var formattedNumeral = num.format(format);
    return formattedNumeral;
}
listviewRenderTypeDefaults.currency = (value: number, format: any) => {
    var num = numeral(value);
    format = `$${format}`;
    var formattedNumeral = num.format(format);
    return formattedNumeral;
}

[].forEach.call(document.getElementsByClassName('integer'), (element: any) => {
    Inputmask('integer', {
        rightAlign: false,
        autoGroup: true,
        groupSeparator: '.'
    }).mask(element);
});

[].forEach.call(document.getElementsByClassName('decimal'), (element: any) => {
    Inputmask('decimal', {
        rightAlign: false,
        autoGroup: true,
        digits: 2,
        radixPoint: ',',
        groupSeparator: '.'
    }).mask(element);
});

[].forEach.call(document.getElementsByClassName('date'), (element: any) => {
    Inputmask('dd-mm-yyyy', {
        placeholder: 'dd/mm/jjjj'
    }).mask(element);
});

[].forEach.call(document.getElementsByClassName('datetime'), (element: any) => {
    Inputmask('datetime', {
        placeholder: 'dd/mm/jjjj uu:mm'
    }).mask(element);
});

[].forEach.call(document.getElementsByClassName('time'), (element: any) => {
    Inputmask('hh:mm:ss', {
        placeholder: "uu:mm'ss"
    }).mask(element);
});

(<any>ko).fileBindings.defaultOptions.noFileText = 'Geen afbeelding gekozen';
(<any>ko).fileBindings.defaultOptions.buttonText = 'Kies afbeelding';
(<any>ko).fileBindings.defaultOptions.changeButtonText = 'Aanpassen';
(<any>ko).fileBindings.defaultOptions.clearButtonText = 'Wis';
(<any>ko).fileBindings.defaultOptions.buttonClass = 'btn btn-primary btn-normal';
(<any>ko).fileBindings.defaultOptions.clearButtonClass = 'btn btn-gray btn-normal';

ko.validation.init({
    decorateInputElement: true,
    errorMessageClass: 'form-error',
    errorElementClass: 'isfalse'
});

ko.validation.insertValidationMessage = (element: Element) => {
    let paragraphElement = document.createElement('p');
    paragraphElement.className = ko.validation.utils.getConfigOptions(element).errorMessageClass || '';
    const parentGroup = element.closest('.input-group') || element;
    ko.validation.utils.insertAfter(parentGroup, paragraphElement);

    return paragraphElement;
}

const html = document.documentElement;
const popups = <HTMLElement[]>Array.from(document.getElementsByClassName('popup'));
const popupToggles = <HTMLElement[]>Array.from(document.getElementsByClassName('toggle-popup'));
const popupCloses = <HTMLElement[]>Array.from(document.getElementsByClassName('close-popup'));
const backfaces = <HTMLElement[]>Array.from(document.getElementsByClassName('backface'));

const closingBackfaces = backfaces
    .filter((element) => !element.classList.contains('no-close'));

popupToggles.forEach(element => {
    element.addEventListener('click', (e: Event) => {
        e.preventDefault();
        closePopups();

        let toggleId = element.dataset.toggle;
        if (toggleId) {
            if (toggleId.startsWith('#')) {
                toggleId = toggleId.substring(1);
            }

            const target = document.getElementById(toggleId);
            if (target) {
                html.classList.add('popup-open');
                target.classList.add('open');
                html.querySelector('.backface')!.classList.add('open');
            }
        }
    });
});

[...popups, ...backfaces].forEach(element => {
    element.classList.add('loaded');
});

[...popupCloses, ...closingBackfaces].forEach(element => {
    element.addEventListener('click', (e: Event) => {
        e.preventDefault();
        closePopups();
    });
});

export function closePopups() {
    html.classList.remove('popup-open');
    popups.forEach(popup => popup.classList.remove('open'));
    backfaces.forEach(backface => backface.classList.remove('open'));
}

export function openPopup(name: string, onClose: (() => void) | null = null) {
    const target = document.getElementById(name);

    if (target) {
        document.documentElement.classList.add('popup-open');
        target.classList.add('open');
        const backface = document.documentElement.querySelector('.backface')!;
        backface.classList.add('open');
        backface.addEventListener('click', () => {
            if(onClose) {
                onClose();
            }
        });
    }
}
